import "./utils/setWebSocket";
import Vue from "vue";
import App from "./App.vue";
import "./common/mixin.scss";
import "./common/main.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import HTTP from "./apis";
import moment from "moment";
import * as utils from "./utils";
import store from "./store/index";
import mixins from "./mixin";
import filters from "./filters";
import * as _storage from "@/utils/storage.js";
import Vconsole from "vconsole";
if (process.env.VUE_APP_CURRENTMODE != 'production') {
  const vConsole = new Vconsole();
  Vue.prototype.$vConsole = vConsole;
  Vue.use(vConsole);
}

Vue.use(ElementUI);
Vue.mixin(mixins);
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.prototype.$moment = moment;
Vue.prototype.$HTTP = HTTP;
Vue.prototype.$utils = utils;
Vue.prototype._storage = _storage;
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
